import { badgeFor, type HudStore } from './store';

export function Badges({ store }: { store: HudStore }) {
  const snap = store.snapshot.value;
  const b = badgeFor(store.source.value, snap);
  return (
    <>
      <div class={`badge ${b.tone}`} role="status" title={b.title}>
        <span class="dot" aria-hidden="true" />
        <span>{b.text}</span>
        {b.detail && <small>{b.detail}</small>}
        {snap && <small class="race-no">Race {snap.raceNo}</small>}
      </div>
      {b.tone === 'lost' && (
        <div class="lost-banner" role="alert">
          <strong>Signal lost — reconnecting to kissaderby.fi</strong>
          <span>Showing last known positions</span>
        </div>
      )}
    </>
  );
}
